import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

export function IcnArrowLeft(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="arrow-left">
      <line x1="13" y1="8" x2="3" y2="8" />
      <path d="M6.5 4.5L3 8l3.5 3.5" />
    </Svg>
  );
}
